"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabResultCount = void 0;
const tslib_1 = require("tslib");
const React = require("react");
const SearchResultTabResultCount_1 = require("../../services/SearchResultTabResultCount");
const constants_1 = require("../../constants");
const useTabResultCount = (tabs, documentPreselectedLanguages, culture, algoliaAnalyticsTags, query) => {
    const [isTabsLoading, setIsTabsLoading] = React.useState(true);
    const [isZeroResult, setIsZeroResult] = React.useState(false);
    const [tabsResultCountMap, setTabsResultCountMap] = React.useState({});
    const [totalResultCount, setTotalResultCount] = React.useState(Number.NaN);
    const previousQueryRef = React.useRef(query);
    const requestIdRef = React.useRef(0);
    const isMountedRef = React.useRef(true);
    React.useEffect(() => {
        const onSearchQueryChange = () => {
            setIsZeroResult(false);
            setIsTabsLoading(true);
        };
        globalThis.addEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        return () => {
            isMountedRef.current = false;
            globalThis.removeEventListener(constants_1.SEARCH_QUERY_CHANGE_EVENT, onSearchQueryChange);
        };
    }, []);
    const refreshTabResultCount = React.useCallback(() => {
        const requestId = ++requestIdRef.current;
        let isCancelled = false;
        const setTabsWithResultCount = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const map = yield SearchResultTabResultCount_1.searchResultTabResultCount.getMap(tabs, documentPreselectedLanguages, culture, algoliaAnalyticsTags);
            if (isCancelled || !isMountedRef.current || requestId !== requestIdRef.current) {
                return;
            }
            const totalCount = Object.values(map).reduce((acc, count) => acc + (count || 0), 0);
            setTotalResultCount(totalCount);
            setIsZeroResult(totalCount === 0);
            setIsTabsLoading(false);
            setTabsResultCountMap(map);
        });
        setTabsWithResultCount();
        return () => {
            isCancelled = true;
        };
    }, [tabs, documentPreselectedLanguages, culture, algoliaAnalyticsTags]);
    React.useEffect(() => {
        return refreshTabResultCount();
    }, []);
    const updateTabResultCount = React.useCallback((tabKey, resultCount) => {
        if (tabKey === constants_1.ALL_TAB_KEY) {
            const currentQuery = query.trim();
            if (previousQueryRef.current === currentQuery)
                return;
            previousQueryRef.current = currentQuery;
            return refreshTabResultCount();
        }
        setTabsResultCountMap(prev => (Object.assign(Object.assign({}, prev), { [tabKey]: resultCount })));
    }, [refreshTabResultCount, query]);
    return {
        tabsResultCountMap,
        totalResultCount,
        isTabsLoading,
        isZeroResult,
        updateTabResultCount,
    };
};
exports.useTabResultCount = useTabResultCount;
